// import React from "react";
//
//
// export default function ActivationHistory() {
//
//
//     return (
//         <div>
//
//             <h2>История расходов по анкетам находиться в
//                 разработке</h2>
//         </div>
//     )
// }

import React from 'react';
import PropTypes from 'prop-types';
import ruLocale from "date-fns/locale/ru";
import DateFnsUtils from "@date-io/date-fns";
import {makeStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

import {Grid, withStyles} from "@material-ui/core";

import Button from "@material-ui/core/Button";

import {DatePicker} from "@material-ui/pickers";
import Select from "../../components/Select";
import Pagination from "@material-ui/lab/Pagination";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import {ThemeProvider} from "@material-ui/styles";

import MuiPickersUtilsProvider from "@material-ui/pickers/MuiPickersUtilsProvider";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {getPurchases} from "../../services/clientsService";
import {getClients} from "../../services/clientsService";
import Filters from "./Filters";
import {parseFiltersFromSearch, syncFiltersToUrl} from "../../utils/urlFilters";

const ACTIVATION_HISTORY_FILTERS_SCHEMA = {
    page: 'number',
    rowsPerPage: 'pageSize',
    dateFrom: 'date',
    dateTo: 'date',
    site: 'string',
    login: 'string',
    name: 'string',
};

const headCell = [
    {id: 'login', numeric: true, disablePadding: false, label: 'Аккаунт'},
    {id: 'name', numeric: true, disablePadding: false, label: 'Имя'},
    {id: 'siteName', numeric: false, disablePadding: false, label: 'Сайт'},
    {id: 'chatCost', numeric: true, disablePadding: false, label: 'Chat'},
    {id: 'mailCost', numeric: true, disablePadding: false, label: 'Mail'},
    {id: 'captchas', numeric: true, disablePadding: false, label: 'Captcha'},
    {id: 'chatActivationsCount', numeric: true, disablePadding: false, label: <span>Активаций<br /> Chat</span>, group: true},
    {id: 'mailActivationsCount', numeric: true, disablePadding: false, label: <span>Активаций<br /> Mail</span>, group: true},
    {id: 'captchaCount', numeric: true, disablePadding: false, label: <span>Кол-во<br /> Captcha</span>, group: true},
    {id: 'total', numeric: true, disablePadding: false, label: 'Расход за период'},
];

/*
 <TableCell component="th" id={labelId} scope="row">
                                                {row.login}
                                            </TableCell>
                                            <TableCell align="left">{row.siteName}</TableCell>
                                            <TableCell align="left">{row.chatCost}</TableCell>
                                            <TableCell align="left">{row.mailCost}</TableCell>
                                            <TableCell align="left">{row.captchas}</TableCell>
                                            <TableCell align="left">{row.chatActivationsCount}</TableCell>
                                            <TableCell align="left">{row.mailActivationsCount}</TableCell>
                                            <TableCell align="left">{row.captchaCount}</TableCell>
                                            <TableCell align="left">{row.chatCost + row.mailCost}</TableCell>
 */

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}


function EnhancedTableHead(props) {
    const {classes, order, orderBy, onRequestSort} = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell
                    key={headCell[0].id}
                    align={'left'}
                    padding={headCell[0].disablePadding ? 'none' : 'default'}
                    sortDirection={orderBy === headCell[0].id ? order : false}
                >

                    {headCell[0].label}

                </TableCell>
                <TableCell
                    key={headCell[1].id}
                    align={'left'}
                    padding={headCell[1].disablePadding ? 'none' : 'default'}
                    sortDirection={orderBy === headCell[1].id ? order : false}
                >

                    {headCell[1].label}

                </TableCell>
                <TableCell
                    key={headCell[2].id}
                    align={'center'}
                    padding={headCell[2].disablePadding ? 'none' : 'default'}
                    sortDirection={orderBy === headCell[2].id ? order : false}
                >

                    {headCell[2].label}

                </TableCell>
                <TableCell
                    key={headCell[3].id}
                    align={'center'}
                    padding={headCell[3].disablePadding ? 'none' : 'default'}
                    sortDirection={orderBy === headCell[3].id ? order : false}
                >

                    {headCell[3].label}

                </TableCell>
                <TableCell
                    key={headCell[4].id}
                    align={'center'}
                    padding={headCell[4].disablePadding ? 'none' : 'default'}
                    sortDirection={orderBy === headCell[4].id ? order : false}
                >

                    {headCell[4].label}

                </TableCell>

                <TableCell
                    key={headCell[5].id}
                    align={'center'}
                    padding={headCell[5].disablePadding ? 'none' : 'default'}
                    sortDirection={orderBy === headCell[5].id ? order : false}
                >

                    {headCell[5].label}

                </TableCell>
                <TableCell
                    key={headCell[6].id}
                    align={'center'}
                    padding={headCell[6].disablePadding ? 'none' : 'default'}
                    sortDirection={orderBy === headCell[6].id ? order : false}
                >

                    {headCell[6].label}

                </TableCell>
                <TableCell
                    key={headCell[7].id}
                    align={'center'}
                    padding={headCell[7].disablePadding ? 'none' : 'default'}
                    sortDirection={orderBy === headCell[7].id ? order : false}
                >

                    {headCell[7].label}

                </TableCell>

                <TableCell
                    key={headCell[8].id}
                    align={'center'}
                    padding={headCell[8].disablePadding ? 'none' : 'default'}
                    sortDirection={orderBy === headCell[8].id ? order : false}
                >

                    {headCell[8].label}

                </TableCell>

                <TableCell
                    key={headCell[9].id}
                    align={'center'}
                    padding={headCell[9].disablePadding ? 'none' : 'default'}
                    sortDirection={orderBy === headCell[8].id ? order : false}
                >

                    {headCell[9].label}

                </TableCell>
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
};


const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const styles = theme => ({
    root: {
        width: '100%',
        textAlign: '-webkit-center'

    },
    typography: {},
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),

    },
    table: {},
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    selectedRow: {
        '&:hover': {
            backgroundColor: theme.palette.action.hover
        }
    },
    selectedPagin: {
        color: '#ffffff'
    },
    '@global': {
        '.MuiPaginationItem-textPrimary.Mui-selected': {
            color: '#ffffff'
        }
    }
});

class TablePayment extends React.Component {

    constructor(props, context) {
        super(props, context);
        let dateTo = new Date();
        dateTo.setHours(dateTo.getHours() - dateTo.getTimezoneOffset() / 60);

        let dateFrom = new Date(dateTo.getTime() - 86400000 * 7);
        dateFrom.setHours(dateFrom.getHours() - dateFrom.getTimezoneOffset() / 60);

        const urlFilters = parseFiltersFromSearch(props.location.search, ACTIVATION_HISTORY_FILTERS_SCHEMA);

        this.state = {
            page: urlFilters.page || 1,
            rowsPerPage: urlFilters.rowsPerPage || 10,
            filters: {
                dateFrom: urlFilters.dateFrom || dateFrom,
                dateTo: urlFilters.dateTo || dateTo,
                site: urlFilters.site || null,
                login: urlFilters.login || null,
                name: urlFilters.name || null,
            }
        }
    }

    fetchPurchases = ({filters, page, rowsPerPage} = {}) => {
        filters = filters || this.state.filters;
        page = page || this.state.page;
        rowsPerPage = rowsPerPage || this.state.rowsPerPage;
        this.props.dispatch(getPurchases({filters, page, rowPerPage: rowsPerPage}));
        syncFiltersToUrl(this.props.history, {...filters, page, rowsPerPage});
    }

    filterBy = (value, type) => {
        const {filters} = this.state;
        if (type === 'dateFrom') {
            value.setHours(value.getHours() - value.getTimezoneOffset() / 60);
        }
        if (type === 'dateTo') {
            value.setHours(value.getHours() - value.getTimezoneOffset() / 60);
        }
        const newFilters = {...filters, [type]: value};
        this.setState({filters: newFilters, page: 1});
        this.fetchPurchases({filters: newFilters, page: 1});
    }

    componentDidMount() {
        let dt = new Date(this.state.filters.dateTo.getTime());
        let df = new Date(this.state.filters.dateFrom.getTime());
        dt.setHours(dt.getHours() - dt.getTimezoneOffset() / 60);
        df.setHours(df.getHours() - df.getTimezoneOffset() / 60);
        const filters = {...this.state.filters, dateFrom: df, dateTo: dt};
        this.setState({filters});
        this.fetchPurchases({filters});
    }

    handleChangePage = (event, newPage) => {
        this.setState({page: newPage});
        this.fetchPurchases({page: newPage});
    };

    handleChangeRowsPerPage = (event) => {
        event = event === 'ВСЕ' ? event : parseInt(event, 10);
        this.setState({rowsPerPage: event, page: 1});
        this.fetchPurchases({rowsPerPage: event, page: 1});
    };

    render() {
        const {dateFrom, dateTo, page, rowsPerPage} = this.state;
        const {classes, purchases, total, pagination} = this.props;
        return (
            <div className={classes.root}>
                <Grid container alignItems={'stretch'} direction={'row'} justify={'wrap'}>
                    <Filters
                        filterBy={this.filterBy}
                        filters={this.state.filters}
                    />
                </Grid>
                <Paper component={'div'} className={classes.paper}>


                    <TableContainer>
                        <Table
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size={'medium'}
                            aria-label="enhanced table"
                        >
                            <EnhancedTableHead
                                classes={classes}
                            />

                            <TableBody>
                                {

                                    purchases.map((row, index) => {

                                    const labelId = `enhanced-table-checkbox-${index}`;

                                    return (

                                        <StyledTableRow
                                        >
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.login}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.name}
                                            </TableCell>
                                            <TableCell align="left">{row.site}</TableCell>
                                            <TableCell align="center">{row.chat_cost / 100 + ' UAH'}</TableCell>
                                            <TableCell align="center">{row.mail_cost / 100 + ' UAH'}</TableCell>
                                            <TableCell align="center">{row.captcha_cost / 100 + ' UAH'}</TableCell>
                                            <TableCell align="center">{row.chat_count}</TableCell>
                                            <TableCell align="center">{row.mail_count}</TableCell>
                                            <TableCell align="center">{row.captcha_count}</TableCell>
                                            <TableCell align="center">{row.total / 100 + ' UAH'}</TableCell>

                                        </StyledTableRow>
                                    );
                                })}

                            </TableBody>

                        </Table>
                    </TableContainer>


                </Paper>
                <Grid container>
                    <Grid item xs={0} sm={0} md={6} lg={8}></Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} style={{
                        display: 'flex',
                        aligItems: 'center',
                        fontSize: '11px',
                        alignItems: 'center',
                        color: 'gray'
                    }}>
                        <Typography variant={'span'} style={{'marginRight': '10px'}}>
                            Записей на странице
                        </Typography>
                        <Select
                            value={rowsPerPage}
                            type={'select'}
                            rowsPerPageOptions={[10, 25, 50, 100, 'ВСЕ']}
                            borderRadius={'20px 20px'}
                            width={'67px'}
                            onChange={this.handleChangeRowsPerPage}
                        />

                        {rowsPerPage !== 'ВСЕ' && <Pagination
                            classes={{selected: classes.selectedPagin}}
                            count={pagination.lastPage || 1}
                            color="primary"
                            page={page}
                            onChange={this.handleChangePage}
                            size={'large'}/>}
                    </Grid>
                </Grid>
                <Typography variant={"h4"}>

                </Typography>
                <Paper component={'div'} className={classes.paper} style={{width: '50%', marginTop:'30px'}}>


                        <TableContainer>
                            <Table
                                className={classes.table}
                                aria-labelledby="tableTitle"
                                size={'medium'}
                                aria-label="enhanced table"
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            key={'total_type'}
                                            align={'left'}
                                            padding={'default'}
                                        >

                                            Тип

                                        </TableCell>
                                        <TableCell
                                            key={'tottal_cost_for_period'}
                                            align={'center'}
                                            padding={'default'}
                                        >

                                            Количество активаций:

                                        </TableCell>
                                        <TableCell
                                            key={'total_count_activations'}
                                            align={'center'}
                                            padding={'default'}
                                        >

                                            Расход за период:

                                        </TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell align={'left'}>
                                             Chat
                                        </TableCell>
                                        <TableCell align={'center'}>
                                            {total.chat_count || ''}
                                        </TableCell>
                                        <TableCell align={'center'}>
                                            {total.chat_cost ? total.chat_cost  / 100 + ' UAH' : ''}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align={'left'}>
                                             Mail
                                        </TableCell>
                                        <TableCell align={'center'}>
                                            {total.mail_count || ''}
                                        </TableCell>
                                        <TableCell align={'center'}>
                                            {total.mail_cost ? total.mail_cost  / 100 + ' UAH' : ''}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align={'left'}>
                                             Captcha
                                        </TableCell>
                                        <TableCell align={'center'}>
                                            {total.captcha_count || ''}
                                        </TableCell>
                                        <TableCell align={'center'}>
                                            {total.captcha_cost ? total.captcha_cost  / 100 + ' UAH' : ''}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align={'left'}>
                                             Общий расход:
                                        </TableCell>
                                        <TableCell align={'left'}>

                                        </TableCell>
                                        <TableCell align={'center'}>
                                            {total.total ? total.total  / 100 + ' UAH' : ''}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>

            </div>
        );
    }
}

const mapStateToProps = store => {

    return {
        purchases: store.Clients.purchases.list,
        total: store.Clients.purchases.total,
        pagination: store.Clients.purchases.pagination || {}
    }
}

export default withRouter(connect(mapStateToProps)(withStyles(styles)(TablePayment)))
// captcha_cost: "0"
// captcha_count: 0
// chat_cost: "3500"
// chat_count: 1
// mail_cost: "3500"
// mail_count: 1
// total: "7000"